export default "__VITE_ASSET__BzlINGs0__"